import React from 'react';
import PropTypes from 'prop-types';
import { cloneDeep, map, reverse } from 'lodash';
import moment from 'moment';
import { AnchorLink } from '@/styles/commonStyles';
import { checkEmpty, getExperience } from '@/utils/commonFunctions';
import {
  StyledGridItem,
  StyledGridItemTitle,
  StyledGridItemDescription,
  StyledGridItemSubTitle,
  StyledGridList,
  StyledButton,
  StyledGridListItem,
  StyledGridItemExtraTitle,
} from './styles';
import { GLOBAL_CONSTANTS } from '@/utils/globalConstants';

export default function RenderExperience({ data, sectionTitle }) {
  const expData = reverse(cloneDeep(data));

  const getTotalTimePeriod = ({ startDateMonth, startDateYear, endDateMonth, endDateYear }) => {
    const { MONTH_MAPPING } = GLOBAL_CONSTANTS;
    const sMonth = MONTH_MAPPING[startDateMonth];
    const eMonth = MONTH_MAPPING[endDateMonth];
    const startDate = new Date().setFullYear(startDateYear, sMonth, 1);
    const endDate = endDateMonth ? new Date().setFullYear(endDateYear, eMonth, 31) : new Date().setDate(31);
    const diffYear = moment(endDate).diff(moment(startDate), 'years');
    const diffMonth = Math.round(moment(endDate).diff(moment(startDate), 'M', true)) - 12 * diffYear;
    if (diffYear) {
      return ` · ${diffYear} ${diffYear > 1 ? 'yrs' : 'yr'} ${diffMonth} ${diffMonth > 1 ? 'mos' : 'mo'}`;
    }
    if (diffMonth) {
      return ` · ${diffMonth} ${diffMonth > 1 ? 'mos' : 'mo'}`;
    }
    return ` · ${diffYear} ${diffYear > 1 ? 'yrs' : 'yr'}`;
  };

  const expRenderer = (title, subTitle, date, extraText, description, url, empType) => (
    <React.Fragment key={title}>
      <StyledGridItemTitle>{title}</StyledGridItemTitle>
      {subTitle ? <StyledGridItemSubTitle>{subTitle}</StyledGridItemSubTitle> : null}
      {empType ? <StyledGridItemExtraTitle>{empType}</StyledGridItemExtraTitle> : null}
      {date ? <StyledGridItemExtraTitle>{date}</StyledGridItemExtraTitle> : null}
      {extraText ? <StyledGridItemExtraTitle>{extraText}</StyledGridItemExtraTitle> : null}
      {!checkEmpty(description) ? (
        <StyledGridList>
          <StyledGridListItem>
            <StyledGridItemDescription>
              {sectionTitle === 'Summary' ? description?.replace('expInYears', getExperience()) : description}
            </StyledGridItemDescription>
          </StyledGridListItem>
        </StyledGridList>
      ) : null}
      {url ? (
        <StyledButton variant="outlined" color="inherit">
          <AnchorLink href={url}>VIEW RESUME</AnchorLink>
        </StyledButton>
      ) : null}
    </React.Fragment>
  );

  return (
    <StyledGridItem className="experience__item">
      {!checkEmpty(expData)
        ? expData.map((expObj) => {
            const { items, ...rest } = expObj || {};
            if (!checkEmpty(items)) {
              const expItems = reverse(cloneDeep(items));
              return map(expItems, ({ title, subTitle, description, url }) => expRenderer(title, subTitle, null, null, description, url, null));
            }
            if (sectionTitle === 'Volunteer Experience') {
              const { organisation, role, cause, startDateMonth, startDateYear, endDateMonth, endDateYear, description } = rest || {};
              let datePeriod = `${startDateMonth} ${startDateYear}`;
              if (endDateMonth && endDateYear) {
                datePeriod += ` - ${endDateMonth} ${endDateYear}`;
              } else {
                datePeriod += ' - Present';
              }
              return expRenderer(role, organisation, datePeriod, cause, description);
            }
            const { expTitle, empType, companyName, location, startDateMonth, startDateYear, endDateMonth, endDateYear, description } = rest || {};
            let subTitle = `${companyName}`;
            if (!endDateMonth) {
              subTitle += ` - ${empType}`
            }
            let datePeriod = `${startDateMonth} ${startDateYear}`;
            if (endDateMonth && endDateYear) {
              datePeriod += ` - ${endDateMonth} ${endDateYear}`;
            } else {
              datePeriod += ' - Present';
            }
            datePeriod += getTotalTimePeriod(rest);
            return expRenderer(expTitle, subTitle, datePeriod, location, description, null, endDateMonth ? empType : null);
          })
        : null}
    </StyledGridItem>
  );
}

RenderExperience.propTypes = {
  data: PropTypes.oneOfType([PropTypes.array]).isRequired,
  sectionTitle: PropTypes.string.isRequired,
};
